// @flow
import React from 'react';
// import ChatSidebarItemLabel from '../ChatSidebarItem/ChatSidebarItemLabel';
import {ChatSidebarItemLabel} from './Labels';
// Import your custom label components
// import {OrdersWithCount, ProductsWithStyling} from './ExampleLabels';

/**
 * Custom label components map
 * Maps item IDs to custom React components for rendering instead of plain text
 */
export const CUSTOM_LABELS = {
  // home: <HomeWithBadge />,
  chat: <ChatSidebarItemLabel />,
};

/**
 * Custom colors map
 * Maps item IDs to custom color configurations
 */
export const CUSTOM_COLORS = {
  chat: {
    backgroundColor: 'rgba(247, 251, 240, 1)',
    borderRadius: 12,
    collapseBackground: 'rgba(247, 251, 240, 1)',
    collapseBorderRadius: 12,
  },
};

/**
 * Get custom label component for an item
 * @param {string} itemId - The item ID
 * @param {string} defaultLabel - The default label text
 * @returns {React$Node} - Custom component or default label
 */
export function getCustomLabel(
  itemId: string,
  defaultLabel: string
): React$Node {
  const customComponent = CUSTOM_LABELS[itemId];
  return customComponent || defaultLabel;
}

/**
 * Check if an item has a custom label component
 * @param {string} itemId - The item ID
 * @returns {boolean} - True if custom component exists
 */
export function hasCustomLabel(itemId: string): boolean {
  return !!CUSTOM_LABELS[itemId];
}

/**
 * Get custom colors for an item
 * @param {string} itemId - The item ID
 * @returns {Object|null} - Custom color configuration or null
 */
export function getCustomColors(itemId: string): Object | null {
  return CUSTOM_COLORS[itemId] || null;
}

/**
 * Check if an item has custom colors
 * @param {string} itemId - The item ID
 * @returns {boolean} - True if custom colors exist
 */
export function hasCustomColors(itemId: string): boolean {
  return !!CUSTOM_COLORS[itemId];
}
